export enum WorkspaceTagsNavigationType {
  DeviceTags = "device-tags",
  MaintenanceTags = "maintenance-tags",
  CaseTags = "case-tags",
}
